// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__SCClv","header":"PatientBlock_header__3Bs2Y","label":"PatientBlock_label__3pKez","option":"PatientBlock_option__2Ft0P"};